import styled from "styled-components";
import { Form } from "react-bootstrap";
import { Swiper } from "swiper/react/swiper-react";

export const StyledSearchForm = styled(Form)`
  height: 60px;
  background: var(--white-color);
  border-radius: 16px;
  display: grid;
  grid-template-columns: 5% [col-start] 80% [col-start] 15% [col-start];
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 992px) {
    grid-template-columns: 5% [col-start] 75% [col-start] 20% [col-start];
  }
  @media screen and (max-width: 576px) {
    grid-template-columns: 10% [col-start] 65% [col-start] 25% [col-start];
  }

  .search-input {
    border: none;
    padding: 0px;
    input {
      font-size: var(--font-size-base);
      color: var(--text-color-muted);
      border-radius: none;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px white inset !important;
      }
      @media screen and (max-width: 768px) {
        font-size: var(--font-size-sm);
      }
    }
  }
  button {
    z-index: 4;
    height: 45px;
    border-radius: 12px;
    font-weight: 500;
    font-size: var(--font-size-base);
    @media screen and (max-width: 1200px) {
      font-size: var(--font-size-sm);
    }
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-xs);
    }
    @media screen and (max-width: 320px) {
      font-size: 10px;
    }
  }
`;

export const ResultCarousel = styled.div`
  width: 100%;
  background: var(--white-color);
  box-shadow: var(--box-shadow3);
  border-radius: 16px;
  position: absolute;
  top: 7rem;
  z-index: 1;
  .all-result-button {
    height: 30px;
    border: 1px solid var(--field-color);
    color: var(--field-color);
    background: transparent;
    border-radius: 6px;
    font-weight: 400;
    font-size: 10px;
  }
  .filter-categories-box {
    border-top: 1px dashed #a4adbc;
  }
`;
export const StyledSwiper = styled(Swiper)`
  .card {
    box-shadow: none;
    max-height: fit-content;
  }
  .prev-button {
    position: absolute;
    top: 50%;
    right: 0px;
    z-index: 2;
  }
  .next-button {
    position: absolute;
    top: 50%;
    left: 0px;
    z-index: 2;
  }
`;

export const ResultCategories = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  font-weight: 500;
  font-size: var(--font-size-base);
  color: var(--text-color-muted);
  .blue-detail {
    color: var(--primary-color);
    font-weight: 500;
    font-size: var(--font-size-base);
  }
`;

export const AllResultWrapper = styled.div`
  background: var(--white-color);
  span {
    font-weight: 500;
    font-size: var(--font-size-lg);
    color: var(--text-color-dark);
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-base);
    }
  }
  .blue-detail {
    color: var(--primary-color);
  }
`;
